<template>
    <div>
        <h4 class="text-center">
            {{ __('Termékek') }}: {{ currentIndex + 1 }}/{{ items.length }}
        </h4>

        <div class="d-flex justify-content-between flex-wrap gap-20">
            <div class="d-flex">
                <div>
                    <div class="products-item-image">
                        <img :src="items[currentIndex].image" :alt="items[currentIndex].name" width="280">
                    </div>
                </div>

                <div class="d-flex flex-direction-column ml-5">
                    <h4>{{ items[currentIndex].name }}</h4>
                    <span>{{ __('Méret') }}: {{ items[currentIndex].size }} </span>
                    <span>{{ __('Szín') }}: {{ items[currentIndex].color }}</span>
                    <span>{{ __('Cikkszám') }}: {{ items[currentIndex].basicCode }}</span>
                </div>
            </div>

            <div style="flex: 1;">
                <div class="mb-5">
                    <label for="return_reason" class="block mb-2 text-sm font-bold text-gray-700 required">
                        {{ __('Visszaküldés oka') }}
                    </label>

                    <select
                        v-model="currentReturnReason"
                        name="return_reason"
                        class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                    >
                        <option :value="null">{{ __('Válassz') }}</option>
                        <option
                            v-for="(value, key, index) in returnReasons"
                            :value="key"
                        >
                            {{ __(value) }}
                        </option>
                    </select>
                </div>

                <template v-if="currentReturnReason === 'quality'">
                    <div class="mb-5">
                        <label for="return_description" class="block mb-2 text-sm font-bold text-gray-700">
                            {{ __('Hiba leírása') }}
                        </label>

                        <textarea
                            v-model="currentReturnDescription"
                            name="return_description"
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                            rows="5"
                        ></textarea>
                    </div>

                    <div class="mb-5">
                        <label for="images" class="block mb-2 text-sm font-bold text-gray-700">
                            {{ __('Fénykép(ek)') }}
                        </label>

                        <input ref="images"
                               type="file"
                               name="images"
                               class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                               max="3"
                               accept="image/*"
                               multiple
                               @change="handleImageChange($event)"
                        />

                        <span v-if="errorMessage"
                              style="color: red; font-weight: bold;"
                        >
                            {{ errorMessage }}
                        </span>

                        <div class="d-flex mt-3"
                             style="gap: 1rem;"
                        >
                            <img
                                v-for="image in images"
                                :src="image"
                                class="product-return-uploaded-image"
                                alt=""
                            >
                        </div>
                    </div>
                </template>

                <div class="mb-5">
                    <label for="return_type" class="block mb-2 text-sm font-bold text-gray-700 required">
                        {{ __('Csere típusa') }}
                    </label>

                    <select
                        v-model="currentReturnType"
                        name="return_type"
                        class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                    >
                        <option :value="null">{{ __('Válassz') }}</option>
                        <option
                            v-for="(value, key, index) in returnTypes"
                            :value="key"
                        >
                            {{ __(value) }}
                        </option>
                    </select>
                </div>

                <div v-if="currentReturnType === 'money'">
                    <div class="mb-5">
                        <label for="account_number" class="block mb-2 text-sm font-bold text-gray-700 required">
                            {{ __('Bankszámlaszám') }}
                        </label>

                        <input
                            v-model="accountNumber"
                            name="bank_account_number"
                            type="text"
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                            maxlength="26"
                            @click="setMask"
                        >
                    </div>

                    <div class="mb-5">
                        <label for="account_owner" class="block mb-2 text-sm font-bold text-gray-700 required">
                            {{ __('Számlatulajdonos neve') }}
                        </label>

                        <input
                            v-model="accountOwner"
                            name="account_owner"
                            type="text"
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                        >
                    </div>
                </div>

                <div v-if="currentReturnType === 'exchange'">
                    <div class="my-5" >
                        <a :href="appUrl"
                           class="btn btn-primary"
                           target="_blank"
                        >
                            {{ __('Válassz egy terméket') }}
                        </a>

                        <span class="ml-3">
                            {{ __('és másold ide a cikkszámát!') }}
                        </span>
                    </div>

                    <div class="mb-5">
                        <label for="exchange_code" class="block mb-2 text-sm font-bold text-gray-700 required">
                            {{ __('Cseretermék kódja') }}
                        </label>

                        <input
                            v-model="currentExchangeCode"
                            name="exchange_code"
                            type="text"
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                        >
                    </div>

                    <div class="mb-5">
                        <label for="exchange_code" class="block mb-2 text-sm font-bold text-gray-700 required">
                            {{ __('Cseretermék mérete') }}
                        </label>

                        <input
                            v-model="currentExchangeSize"
                            name="exchange_size"
                            type="text"
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
                        >
                    </div>
                </div>


                <div class="d-flex justify-content-between">
                    <button
                        v-if="currentIndex !== 0"
                        @click="goToPrevItem"
                    >
                        {{ __('Előző termék') }}
                    </button>

                    <button
                        v-if="currentIndex !== items.length - 1 && checkNext()"
                        class="ml-auto"
                        @click="goToNextItem"
                    >
                        {{ __('Következő termék') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="my-5 text-center">
            <button class="mx-5" @click="goBack">
                {{ __('Vissza a termék választáshoz') }}
            </button>

            <button
                v-if="currentIndex === items.length - 1 && checkNext()"
                class="mx-5"
                @click="saveItems"
            >
                {{ __('Tovább az összegzéshez') }}
            </button>
        </div>
    </div>
</template>

<script>
import IMask from "imask";

export default {
    name: 'ProductReturnProducts',

    props: {
        selectedItems: {
            type: Array,
            required: true
        },
        returnReasons: {
            type: Object,
            required: true
        },
        returnTypes: {
            type: Object,
            required: true
        },
        appUrl: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            items: this.selectedItems,
            currentIndex: 0,
            currentReturnReason: null,
            currentReturnType: null,
            currentReturnDescription: null,
            accountNumber: null,
            accountOwner: null,
            currentExchangeCode: null,
            currentExchangeSize: null,
            maxImagesCount: 3,
            images: [],
            errorMessage: null,
        }
    },

    watch: {
        selectedItems() {
            this.items = this.selectedItems
        },

        currentReturnReason() {
            this.currentReturnDescription = null
            this.images = []
        },
    },

    methods: {
        checkNext() {
            if (this.currentReturnReason === null || this.currentReturnType === null) {
                return false;
            }

            if (this.currentReturnType === 'money' && (this.accountNumber === null || this.accountNumber === '' || this.accountOwner === null || this.accountOwner === '')) {
                return false;
            }

            if (this.currentReturnType === 'exchange' && (this.currentExchangeCode === null || this.currentExchangeCode === '' || this.currentExchangeSize === null || this.currentExchangeSize === '')) {
                return false;
            }

            return true;
        },

        goToNextItem() {
            if (this.currentReturnReason === 'quality'
                && this.currentReturnDescription === null
                && this.images.length === 0
                && ! confirm(this.__('Biztos nem szeretnéd kitölteni a hiba leírás mezőt, illetve képet feltölteni? Ez segítene a hiba egyértelműbb beazonosításában.'))
            ) {
                return
            }

            this.saveCurrentAttributes();
            this.resetCurrentAttributes();

            this.currentIndex++;
            this.loadItemData();
        },

        goToPrevItem() {
            this.saveCurrentAttributes();
            this.resetCurrentAttributes();

            this.currentIndex--;
            this.loadItemData();
        },

        saveItems() {
            if (this.currentReturnReason === 'quality'
                && this.currentReturnDescription === null
                && this.images.length === 0
                && ! confirm(this.__('Biztos nem szeretnéd kitölteni a hiba leírás mezőt, illetve képet feltölteni? Ez segítene a hiba egyértelműbb beazonosításában.'))
            ) {
                return
            }

            this.saveCurrentAttributes();
            this.resetCurrentAttributes();

            this.$emit('return-items', this.items, {
                'account_number': this.accountNumber,
                'account_owner': this.accountOwner
            });
        },

        goBack() {
            this.$emit('go-back');
        },

        saveCurrentAttributes() {
            this.items[this.currentIndex]['return_reason'] = this.currentReturnReason;
            this.items[this.currentIndex]['return_type'] = this.currentReturnType;
            this.items[this.currentIndex]['return_description'] = this.currentReturnDescription;
            this.items[this.currentIndex]['exchange_code'] = this.currentExchangeCode;
            this.items[this.currentIndex]['exchange_size'] = this.currentExchangeSize;
            this.items[this.currentIndex]['images'] = this.images;
        },

        loadItemData() {
            this.currentReturnReason = this.items[this.currentIndex]['return_reason'] ?? null;
            this.currentReturnType = this.items[this.currentIndex]['return_type'] ?? null;
            this.currentExchangeCode = this.items[this.currentIndex]['exchange_code'] ?? null;
            this.currentExchangeSize = this.items[this.currentIndex]['exchange_size'] ?? null;

            this.$nextTick(() => {
                this.currentReturnDescription = this.items[this.currentIndex]['return_description'] ?? null;
                this.images = this.items[this.currentIndex]['images'] ?? [];
            })
        },

        resetCurrentAttributes() {
            this.currentReturnReason = null;
            this.currentReturnType = null;
            this.currentReturnDescription = null;
            this.currentExchangeCode = null;
            this.currentExchangeSize = null;
            this.errorMessage = null;

            if (this.images.length > 0) {
                this.images = [];
                this.$refs.images.value = ''
            }
        },

        handleImageChange(event) {
            this.images = []
            this.errorMessage = null

            const selectedImages = Array.from(event.target.files);
            let isAllImage = true
            let tempImages = []

            if (selectedImages.length > this.maxImagesCount) {
                event.target.value = ''
                this.errorMessage = this.__('Legfeljebb ' + this.maxImagesCount + ' fájlt választhatsz ki!')

                return
            }

            selectedImages.forEach(file => {
                if (file.type.startsWith('image/')) {
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        tempImages.push(e.target.result);
                    };

                    reader.readAsDataURL(file);
                } else {
                    isAllImage = false
                }
            });

            if (! isAllImage) {
                event.target.value = ''
                this.errorMessage = this.__('Csak képfájlokat választhatsz ki!')

                return
            }

            this.images = tempImages
        },

        setMask() {
            let maskOptions = {
                bankAccount: { mask: '00000000-00000000-00000000' },
            };
            let bankAccountNumberMask = IMask(document.querySelector('input[name="bank_account_number"]'), maskOptions.bankAccount);
        },
    },
}
</script>

<style lang="scss" scoped>
div.products-item-image {
    background: #fff;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.43);
}

img.product-return-uploaded-image {
    width: 60px;
    height: 80px;
    border: solid 2px black;
    border-radius: 10px;
    object-fit: cover;
}
</style>
